<template>
  <v-dialog
    v-model="showModal"
    persistent
    :max-width="next ? '800px' : '500px'"
    style="min-width: 500px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1" v-if="!modalloading">
        <span class="pt-2 pb-1" style="font-size: 21px">
          <strong>{{ getTitle }}</strong>
          {{ getType }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            v-if="showAttributeType || showUnsubscribeType"
            cols="12"
            md="12"
          >
            <el-simple-table :items="mainDataList" />
          </v-col>
          <v-col v-if="showRejectType" cols="12" md="12">
            <el-simple-table :items="tebleItems" />
          </v-col>

          <v-col v-if="showSelect" cols="12" md="12">
            <el-autocomplete
              @change="setDescriptions()"
              required
              :items="classifiers['reject-reason']"
              itemvalue="value"
              itemtext="text"
              :label="documentKind == 'PP' ? 'Atsisakymo įregistruoti priežastis' : 'Atsisakymo išregistruoti įgaliojimą priežastis' "
              tooltip="Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Modalas. Pranešimo atmetimo priežastis"
              v-model="formData.reject_reason_id"
            />
          </v-col>
          <template v-if="showDescriptions">
            <v-col class="pb-0" cols="12" md="12">
              <el-textarea
              required
              :counter="2000"
              label="Aprašymas (LT)"
              v-model="formData.description_lt"
              /></v-col>
            <v-col class="pb-0" cols="12" md="12">
              <el-textarea
              required
              :counter="2000"
              label="Aprašymas (EN)"
              v-model="formData.description_en"
            /></v-col>
          </template>
          <v-col v-if="next" cols="12" md="12">
            <el-PDF-viewer download :file="pdfFile" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <el-button
          color="secondary"
          @click.native="cancel()"
          :loading="loading || requestLoading"
          title="Atšaukti"
        />
        <el-button
          v-if="!next"
          color="primary"
          @click.native.stop="goNext()"
          :loading="loading || requestLoading"
          title="Tęsti"
        />
        <el-button
          v-if="showUnsubscribeTypeBtn"
          color="danger"
          @click.native.stop="submit()"
          :loading="loading || requestLoading"
          title="Išregistruoti"
        />
        <el-button
          v-if="showRejectTypeBtn"
          color="primary"
          @click.native.stop="submit()"
          :loading="loading || requestLoading"
          title="Atmesti"
        />
        <el-button
          v-if="showAttributeTypeBtn"
          color="primary"
          @click.native.stop="submit()"
          :loading="loading || requestLoading"
          title="Įvesti požymį"
        />
         <el-button
          v-if="showRegisterTypeBtn"
          color="primary"
          @click.native.stop="submit()"
          :loading="loading || requestLoading"
          title="Įregistruoti"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ModalDocumentAction',

  props: {
    documentNo: String,
    value: Boolean,
    modalType: String,
    basis: String,
    basisText: String,
    injournalId: [String, Number],
    mandatePersonData: [Object, Boolean],
    documentKind: String,
    number: String,
    requestLoading: Boolean,
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      formData: {},
      classifiers: {},
      searchBy: null,
      loading: false,
      next: false,
      pdfFile: {},
    }
  },
  computed: {
    showDescriptions() {
      return this.modalType === 'reject' && !this.next && this.formData.reject_reason_id
    },
    showAttributeType() {
      return this.modalType === 'attribute' && !this.next
    },
    showUnsubscribeType() {
      return this.modalType === 'unsubscribe' && !this.next
    },
    showRejectType() {
      return (this.modalType === 'reject' || this.modalType === 'register')  && !this.next
    },
    showAttributeTypeBtn() {
      return this.modalType === 'attribute' && this.next
    },
    showUnsubscribeTypeBtn() {
      return this.modalType === 'unsubscribe' && this.next
    },
    showRegisterTypeBtn() {
      return this.modalType === 'register' && this.next
    },
    showRejectTypeBtn() {
      return this.modalType === 'reject' && this.next
    },
    getTitle() {
      return `${this.getDocumentNo}`
    },
    showSelect() {
      return this.modalType === 'reject' && !this.next
    },
    mainDataList() {
      return this.mandatePersonDataList.concat(this.tebleItems)
    },
    mandatePersonDataList() {
      switch (this.mandatePersonData.type) {
        case 'FIZ':
          return [
            {
              title: 'Požymis',
              value: this.documentKind == 'PP' || this.documentKind == 'ITPSP' ? 'Prokūra šio asmens atžvilgiu pasibaigė' : 'Įgaliojimas šio asmens atžvilgiu pasibaigė',
              tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Modalas. Požymis",
              hide: this.documentKind == 'PP' || this.documentKind == 'ITPSP'
            },
            {
              title: '',
              value: this.mandatePersonData?.role || '',
              enumName: 'userRoles',
            },
            {
              title: 'Vardas',
              value: this.mandatePersonData?.name || '',
            },
            {
              title: 'Pavardė',
              value: this.mandatePersonData?.lastname || '',
            },
            {
              title: 'Asmens kodas',
              value: this.mandatePersonData?.code || '',
            },
          ]
        case 'JUR':
          return [
            {
              title: 'Požymis',
              value: this.documentKind == 'PP' || this.documentKind == 'ITPSP' ? 'Prokūra šio asmens atžvilgiu pasibaigė' : 'Įgaliojimas šio asmens atžvilgiu pasibaigė',
              tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Modalas. Požymis",
              hide: this.documentKind == 'PP' || this.documentKind == 'ITPSP'
            },
            {
              title: '',
              value: this.mandatePersonData?.role || '',
              enumName: 'userRoles',
            },
            {
              title: 'Juridinio asmens kodas',
              value: this.mandatePersonData?.code || '',
            },
            {
              title: 'Juridinio asmens pavadinimas',
              value: this.mandatePersonData?.fullname || '',
            },
          ]
        case 'UZS':
          return [
            {
              title: 'Požymis',
              value: 'Įgaliojimas šio asmens atžvilgiu pasibaigė',
              tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Modalas. Požymis",
              hide: this.documentKind == 'PP' || this.documentKind == 'ITPSP'
            },
            {
              title: '',
              value: this.mandatePersonData?.role || '',
              enumName: 'userRoles',
            },
            {
              title: 'ILTU kodas',
              value: this.mandatePersonData?.code || '',
            },
            {
              title: 'Vardas',
              value: this.mandatePersonData?.name || '',
            },
            {
              title: 'Pavardė',
              value: this.mandatePersonData?.lastname || '',
            },
            {
              title: 'Gimimo data',
              value: this.mandatePersonData?.birth_date || '',
            },
            {
              title: 'Šalis',
              value: this.mandatePersonData?.country || '',
            },
          ]
        default:
          return []
      }
    },
    tebleItems() {
      switch (this.modalType) {
        case 'unsubscribe':
          return [
            {
              title: 'Pasibaigimo pagrindas',
              value: this.basis || '',
              enumName: 'inJournalBasis',
              hide: this.basis == 'notary-action'
            },
            {
              title: 'Pasibaigimo pagrindas',
              value: this.basisText || '',
              hide: this.basis != 'notary-action'
            },
            {
              title: 'Pasibaigimo data',
              value: moment().format('YYYY-MM-DD HH:mm'),
            },
          ]
        case 'reject':
          return [
            {
              title: 'Atmetimo data',
              value: moment().format('YYYY-MM-DD  HH:mm'),
              tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Modalas. Atmetimo data"
            },
          ]
        case 'attribute':
          return [
            // {
            //   title: 'Panaikinimo / atsisakymo požymis',
            //   value: this.basis || '',
            //   enumName: 'inJournalBasis',
            // },
            {
              title: 'Požymio data',
              value: moment().format('YYYY-MM-DD HH:mm'),
              tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Modalas. Požymio data"
            },
          ]
          case 'register':
          return [
            {
              title: 'Įregistravimo data',
              value: moment().format('YYYY-MM-DD HH:mm'),
            },
          ]

        default:
          return []
      }
    },
    getType() {
      switch (this.modalType) {
        case 'unsubscribe':
          return 'Išregistravimas'
        case 'reject':
          return 'Atmetimas'
        case 'attribute':
          return 'Įvesti požymį'
         case 'register':
          return 'Įregistruoti'
        default:
          return ''
      }
    },
    getDocumentNo() {
      return this.number
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  created() {
    if(this.modalType === 'reject'){
       this.getClassifiers()
    }
    this.modalloading = false
  },
  methods: {
    setDescriptions(){
      let id = this.formData.reject_reason_id
      let langLt = this.classifiers['reject-reason-descriptions'].lt
      let langEn = this.classifiers['reject-reason-descriptions'].en
      let descriptionLt =  langLt.filter((item) => item.value === id)[0]
      let descriptionEn =  langEn.filter((item) => item.value === id)[0]
      this.$set(this.formData, 'description_lt', descriptionLt.text)
      this.$set(this.formData, 'description_en', descriptionEn.text)
    },
    getPdfFile() {
      this.pageloading = true
      let type = ''
      switch (this.modalType) {
        case 'reject':
          type = 'reject'
          break;
        case 'unsubscribe':
          type = 'deregister'
          break;
        case 'attribute':
          type = 'mark-person'
          break;
        case 'register':
          type = 'register'
          break;
        default:
          break;
      }
      let url = `in-journals/${this.injournalId}/preview/${type}`
      if(this.showSelect){
        let formData = this.formData
        this.$axios
        .post(url, formData)
        .then((res) => {
          this.pdfFile = res.data
          this.pdfFile.original_filename = 'Peržiūra.pdf'
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
        })
      } else {
        this.$axios
        .post(url)
        .then((res) => {
          this.pdfFile = res.data
          this.pdfFile.original_filename = 'Peržiūra.pdf'
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
        })
      }
    },
    goNext() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.getPdfFile()
          this.next = true
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    clear() {
      this.formData = { foreigner: false }
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    },
    closeModal() {
      this.showModal = false
    },
    cancel() {
      this.closeModal()
    },
    submit() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          let item = this.formData
          item.modalType = this.modalType
          this.$emit('confirmDocumentAction', item)
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    getClassifiers() {
      this.loadDefault = true
      let arr = []
      let search = {}
      search.key = 'type'
      search.value = this.documentKind
      arr.push(search)
      let requiredClassifiers = { classifiers: ['reject-reason','reject-reason-descriptions'], search: arr }
      this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.classifiers = res.data.classifiers
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
